import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import DiscordIcon from '../images/discord.svg'


export default class DiscordButton extends PureComponent {
  render() {
    const svgStyle = {
      width: this.props.width,
      fill: this.props.fill,
      ...this.props.svgStyle,
    }

    return (
      <a
        className='link'
        rel='external'
        target='_blank'
        href='https://discord.gg/jwNUrk2'
        style={this.props.style}
      >
        <DiscordIcon style={svgStyle} />
      </a>
    )
  }
}

DiscordButton.propTypes = {
  width: PropTypes.number,
  fill: PropTypes.string,
  style: PropTypes.object
}

DiscordButton.defaultProps = {
  width: 36,
  style: {},
  svgStyle: {},
  fill: '#23272A'
}



// WEBPACK FOOTER //
// ./src/components/discord_button.js